<template>
  <div class="circle-slice-center pointer-events-none">
    <div class="background pointer-events-none" v-if="!questionsAnswerd"></div>
    <router-link
      :to="{ name: 'profile' }"
      class="content rounded-full pointer-events-auto"
    >
      <div
        class="w-full h-full rounded-full"
        :class="{ invisible: questionsAnswerd }"
      >
        <span
          class="circle-slice-label font-bold text-chplus-regular pointer-events-none"
          >{{ $t("components.nav.circular_menu.menu_center") }}</span
        >
      </div>
      <icon-notification
        v-if="showNotification"
        top="10%"
        right="50%"
        transform="translate(50%,-50%)"
      />
    </router-link>
  </div>
</template>

<script>
import IconNotification from "@/components/icons/IconNotification";
export default {
  name: "CircularSliceCenter",
  components: { IconNotification },
  props: {
    questionsAnswerd: {
      type: Boolean,
      default: true
    },
    showNotification: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.circle-slice-center,
.circle-slice-center .background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.circle-slice-center .background {
  background-image: url("~@/assets/menu/menu-center-body.svg");
}
.circle-slice-center .content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 35.561%;
  height: 35.561%;
}
.circle-slice-center .content::after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  width: 90%;
  height: 90%;
  transform: translate(-50%, -50%) scale(0.1);
  background: radial-gradient(#ffffff44, #ffffff00);
  box-shadow: rgba(255, 255, 255, 0.1) 0 0 0.1rem;
  transition: opacity 0.1s ease, transform 0.1s ease;
  opacity: 0;
}
.circle-slice-center:hover .content::after {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.circle-slice-center:active .content::after {
  transform: translate(-50%, -50%) scale(1.1);
}
.circle-slice-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 1rem;
  word-break: break-word;
}
</style>
